import { useCallback } from 'react';

export const useCanvasPanning = ({ scrollContainerRef, panRef, setIsPanning }) => {
  const startPan = useCallback((e) => {
    if (!scrollContainerRef.current) return false;

    panRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      scrollLeft: scrollContainerRef.current.scrollLeft,
      scrollTop: scrollContainerRef.current.scrollTop
    };
    setIsPanning(true);
    return true;
  }, [scrollContainerRef, panRef, setIsPanning]);

  const updatePan = useCallback((e) => {
    if (!panRef.current || !scrollContainerRef.current) return false;

    const dx = e.clientX - panRef.current.startX;
    const dy = e.clientY - panRef.current.startY;
    scrollContainerRef.current.scrollLeft = panRef.current.scrollLeft - dx;
    scrollContainerRef.current.scrollTop = panRef.current.scrollTop - dy;
    return true;
  }, [scrollContainerRef, panRef]);

  const stopPan = useCallback(() => {
    panRef.current = null;
    setIsPanning(false);
  }, [panRef, setIsPanning]);

  return { startPan, updatePan, stopPan };
};
